import { useEffect, useState } from "react";
import { Lightbulb, Send, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import api, { formatApiError } from "@/api";
import { toast } from "sonner";

export default function IdeaBox() {
  const [open, setOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [name, setName] = useState("");
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);

  useEffect(() => {
    const onScroll = () => setCollapsed(window.scrollY > 160);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/ideas", { name, message });
      toast.success("Merci ! Votre idée a été glissée dans la boîte.");
      setMessage("");
      setOpen(false);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSending(false);
    }
  };

  return (
    <div className={`ideabox${open ? " open" : ""}${collapsed ? " collapsed" : ""}`} data-testid="idea-box">
      <button type="button" className="ideabox-tab" onClick={() => setOpen(!open)}
        data-testid="idea-box-tab" aria-expanded={open} aria-label="Ouvrir la boîte à idées">
        <Lightbulb className="h-4 w-4" />
        <span>Boîte à idées</span>
      </button>
      <div className="ideabox-panel" data-testid="idea-box-panel">
        <div className="ideabox-panel-inner">
          <div className="ideabox-slot" aria-hidden="true"><div className="ideabox-slot-bar" /></div>
          <div className="flex items-center justify-between mb-1.5">
            <p className="text-sm font-bold text-slate-800">Boîte à idées publique</p>
            <button type="button" onClick={() => setOpen(false)} aria-label="Fermer la boîte à idées"
              className="text-slate-400 hover:text-slate-600 p-1" data-testid="idea-box-close">
              <X className="h-4 w-4" />
            </button>
          </div>
          <p className="text-xs text-slate-500 leading-relaxed mb-3">
            Une idée d'événement, d'activité ou d'amélioration ? Glissez votre bulletin dans la boîte — le bureau lit tout.
          </p>
          <form onSubmit={submit} className="space-y-2.5">
            <Input value={name} onChange={(e) => setName(e.target.value)} maxLength={120}
              placeholder="Votre prénom ou nom (facultatif)" data-testid="idea-box-name" />
            <textarea value={message} onChange={(e) => setMessage(e.target.value)} required minLength={3} maxLength={1500}
              rows={4} placeholder="Votre idée…" data-testid="idea-box-message"
              className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring" />
            <Button type="submit" disabled={sending} className="w-full bg-emerald-600 hover:bg-emerald-700" data-testid="idea-box-submit">
              {sending ? "Envoi…" : "Glisser mon bulletin"} <Send className="h-3.5 w-3.5 ml-1.5" />
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
